/**
 * What the supporter has left to give. Absent for control, and for the share links, feed entries and
 * email links that also reach the page.
 */
const NEXT_STEP_VALUES = ['comment', 'done'] as const;
export type VideoConfirmationNextStep = (typeof NEXT_STEP_VALUES)[number];

export function parseNextStep(value: string | undefined): VideoConfirmationNextStep | undefined {
	return NEXT_STEP_VALUES.find((step) => step === value);
}
